//接口地址
const basePath = process.env.NODE_ENV === 'production' ? process.env.VUE_APP_BASEPATH : '/api';
// const basePath ="https://develop.wosaiapp.cn/api";//开发环境
// const basePath = "https://jkpj-qlc-web.guahao.cn/api/";//生产环境
// const basePath =  process.env.VUE_APP_BASEPATH;

//设置项
const setting = {
  mockbasePath: "http://localhost:3000/",
  mockData: false,//是否使用mock数据
  basePath: basePath,//接口位置
  pageNum: 10, //分页每页记录数
  pageSizes: [10, 20, 50, 100,150,200],
  sysName: process.env.VUE_APP_TITLE,
  upLoadSize: 50,//上传文件大小限制（MB）
  timeout: 1200000,
}


//导航菜单
const menu = {
  OMSMenu: [
    {id: "0101", name: "应用管理", path: "/appAll", menuIcon: "el-icon-s-opportunity" },
    { id: "0102", name: "数据字典", path: "/dict", menuIcon: "el-icon-notebook-2" },
    // { id: "0103", name: "菜单管理", path: "/menu", menuIcon: "el-icon-menu" },
    // { id: "0104", name: "用户角色", path: "/role", menuIcon: "role" },
    // { id: "0105", name: "用户管理", path: "/account", menuIcon: "el-icon-user-solid"},
    { id: "0106", name: "AI厂商", path: "/AIVendor", menuIcon: "AI" },
    { id: "0107", name: "AI模型", path: "/AIModel", menuIcon: "AImodel" },
    { id: "0108", name: "租户管理", path: "/tenant", menuIcon: "el-icon-s-shop" },
    { id: "0109", name: "租户账号", path: "/tenantAccount", menuIcon: "el-icon-s-custom" },
    { id: "0110", name: "租户模型", path: "/tenantModel", menuIcon: "qudao" },
    {
      id: "0111", name: "Tokens统计", menuIcon: "el-icon-s-data", children: [
        { id: "011101", name: "总量统计", path: "/totalQuantity" },
        // { id: "011102", name: "按厂商模型统计", path: "/totalModel" },
        // { id: "011103", name: "按租户统计", path: "/totalTenant" },
        { id: "011104", name: "按账号日统计", path: "/totalTenantDay" },
        { id: "011105", name: "按账号月统计", path: "/totalTenantMonth" },
      ]
    },
       
        
  ],
  backendMenu: [
    { id: "0201", name: "邀请码管理", path: "/invite", menuIcon: "el-icon-finished" },
    { id: "0202", name: "用户管理", path: "/member", menuIcon: "el-icon-user-solid" },
    {
      id: "0203", name: "Tokens统计", menuIcon: "el-icon-s-data", children: [
        { id: "020301", name: "总量统计", path: "/totalQuantity" },
        // { id: "020302", name: "按模型统计", path: "/totalModel" },
        // { id: "020303", name: "按帐号统计", path: "/totalAccount" },
        { id: "020304", name: "按帐号日统计", path: "/totalDay" },
        { id: "020305", name: "按帐号月统计", path: "/totalMonth" },
      ]
    },
  ]
}

export {
    setting,
    menu
};